import { property, state } from 'lit/decorators.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Constructor<T = {}> = abstract new (...args: any[]) => T;

export interface MixinBase {
    connectedCallback?(): void;
    disconnectedCallback?(): void;
    requestUpdate(): void;
}

/**
 * Mixin to add opportunity-related properties to a LitElement-based class.
 * Portiert aus dem web-components-Modul.
 * @param Base - The base class to extend.
 * @returns A new class extending the base class with opportunity properties.
 */
export function withOpportunities<TBase extends Constructor<MixinBase>>(Base: TBase) {
    abstract class WithOpportunities extends Base {
        @property({ type: String, attribute: 'opportunity-description' })
        opportunityDescription = '';

        @property({ type: String, attribute: 'opportunity-destination' })
        opportunityDestination = '';

        @property({ type: String, attribute: 'opportunity-source' })
        opportunitySource = '';

        @property({ type: String, attribute: 'opportunity-source-url' })
        opportunitySourceUrl = (top || window)?.location?.href || '';

        @property({ type: String, attribute: 'opportunity-title' })
        opportunityTitle = '';

        @property({ type: String, attribute: 'opportunity-type' })
        opportunityType = '';

        @property({ type: String, attribute: 'opportunity-owning-team' })
        // eslint-disable-next-line @typescript-eslint/no-inferrable-types
        opportunityOwningTeam? = '';

        @property({ type: String, attribute: 'opportunity-product-brand' })
        opportunityProductBrand = '';

        @property({ type: String, attribute: 'opportunity-product-id' })
        opportunityProductId = '';

        @state()
        opportunityOriginatingObjectTag: string = '';
    }

    return WithOpportunities;
}
